import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

interface PermissionGateProps {
  resource: string;
  action: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PermissionGate: React.FC<PermissionGateProps> = ({ 
  resource, 
  action, 
  children, 
  fallback = null 
}) => {
  const { can } = usePermissions();
  
  if (can(resource, action)) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
};

interface RoleGateProps {
  role: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RoleGate: React.FC<RoleGateProps> = ({ 
  role, 
  children, 
  fallback = null 
}) => {
  const { hasRole } = usePermissions();
  
  if (hasRole(role)) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
};

interface MultiPermissionGateProps {
  permissions: Array<{ resource: string; action: string }>;
  requireAll?: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const MultiPermissionGate: React.FC<MultiPermissionGateProps> = ({ 
  permissions, 
  requireAll = false, 
  children, 
  fallback = null 
}) => {
  const { canAll, canAny } = usePermissions();
  
  const hasPermission = requireAll ? canAll(permissions) : canAny(permissions);
  
  if (hasPermission) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
};